import * as z from "zod";
import { MarketingAgentAnalyticsInputSchema } from "./common";

const TriggerEventDistributionItemSchema = z.object({
  eventType: z.string(),
  count: z.number(),
});

export const getMarketingAgentTriggerEventDistribution = {
  name: "getMarketingAgentTriggerEventDistribution" as const,
  input: MarketingAgentAnalyticsInputSchema,
  output: z.array(TriggerEventDistributionItemSchema),
};
